import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { ICategory } from 'types/GlobalCategory'
import { sortAlphabeticalAsc } from 'utils/sortHelper'

// select all categories
const selectAll = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.CategoryStore.data
  ],
  (data) => data
)

const regroup = (categories: ICategory[]) => {
  const mapper: { [slug: string]: ICategory } = {}

  categories.forEach((cat) => (mapper[cat.slug] = cat))

  return mapper
}

const filterByKey = (
  data: {
    [slug: string]: ICategory
  },
  key: 'dashboard' | 'entity' | 'metric',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  lang: 'sv' | 'en'
) => {
  return regroup(
    Object.values(data)
      .filter((item) => item[key])
      .sort((a, b) => sortAlphabeticalAsc(a.title[lang], b.title[lang]))
  )
}

export const selectAllDashboardCategories = createSelector(
  [selectAll, (_: ApplicationState, lang: 'sv' | 'en') => lang],
  (data, lang) => filterByKey(data, 'dashboard', lang)
)

export const selectAllEntityCategories = createSelector(
  [selectAll, (_: ApplicationState, lang: 'sv' | 'en') => lang],
  (data, lang) => filterByKey(data, 'entity', lang)
)

export const selectAllMetricCategories = createSelector(
  [selectAll, (_: ApplicationState, lang: 'sv' | 'en') => lang],
  (data, lang) => filterByKey(data, 'metric', lang)
)
